import { render, staticRenderFns } from "./FacultyCoeQpSets.vue?vue&type=template&id=ef759e5c"
import script from "./FacultyCoeQpSets.vue?vue&type=script&lang=js"
export * from "./FacultyCoeQpSets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports